export default {
  GET_METHOD: 'GET',
  POST_METHOD: 'POST',
  PATCH_METHOD: 'PATCH',
  DELETE_METHOD: 'DELETE',
}
